import {METRICS} from "../../data/resume";

export const MetricsBand = () => (
    <section id="impact" className="impact-section" aria-label="Impact metrics">
        <div className="shell impact-layout">
            <h2>Built with purpose.<br />Measured in outcomes.</h2>
            <dl className="impact-list">
                {METRICS.map(metric => <div key={metric.label}>
                    <dt><strong>{metric.value}</strong><span>{metric.label}</span></dt>
                    <dd>{metric.detail}</dd>
                </div>)}
            </dl>
        </div>
    </section>
);
